import * as Styled from './styled'
import { Props } from './interfaces'
import { ChangeEvent } from 'react'

function Input({ register, name, ...props }: Props) {
  const reactHookFormProps = register?.(name)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(event)
    return reactHookFormProps?.onChange?.(event)
  }

  return <Styled.Input {...reactHookFormProps} {...props} onChange={handleChange} />
}

Input.defaultProps = {
  placeholder: ' ',
}

export default Input
